// extracted by mini-css-extract-plugin
module.exports = {"wound-image":"style_wound-image__1WczD"};